module.exports = __webpack_public_path__ + "img/user.9a0b61ae.jpeg";